import { Tabs } from '@mui/material';
import { useContext } from 'react';
import { Trans } from 'react-i18next';
import { styled } from 'styled-components';

import { AppContext } from '../../app/context';
import { TTab } from '../../app/router/tabs';

import LinkTab from './link-tab';

interface IProps {
  selectedTab: TTab;
  selectTab: (tab: TTab) => void;
}

function TabBar({ selectedTab, selectTab }: IProps): React.JSX.Element {
  const {
    zone: { current: currentZone },
  } = useContext(AppContext);

  let route = '';
  if (currentZone?.administrativeLevel === 'world') route = `/`;
  else if (currentZone?.administrativeLevel === 'country') route = `/${currentZone.countryCode}/`;
  else if (currentZone?.administrativeLevel === 'region')
    route = `/${currentZone.countryCode}/${encodeURIComponent(currentZone.name)}/`;
  else if (currentZone) route = `/${currentZone.countryCode}/${currentZone.code}/`;

  return (
    <Tabs
      indicatorColor="primary"
      onChange={(_, value) => selectTab(value)}
      value={selectedTab}
      variant="fullWidth"
    >
      <StyledLinkTab
        label={<Trans i18nKey="bicycle_facilities.navigation.stats" />}
        to={`${route}stats`}
        value="stats"
      />
      <StyledLinkTab
        label={<Trans i18nKey="bicycle_facilities.navigation.contributions" />}
        to={`${route}contributions`}
        value="contributions"
      />
    </Tabs>
  );
}

const StyledLinkTab = styled(LinkTab)`
  && {
    text-transform: none;
    min-width: 72px;
  }
`;

export default TabBar;
